import { Config } from "../../../configurations/config";
export const ViewEmployees_API = {
  //------------------------ View Employee APIS -----------------------//

  GetViewEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployeesInfo`,
  GetDesignationList: `${Config.server_url}${Config.api_prefix}/Employee/GetDesignationsList`,
  GetStatusList: `${Config.server_url}${Config.api_prefix}/Employee/GetEmployeeStatusList`,
  ExportToExcel:`${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployeesInfo/ExportToExcel`,

  //------------------------ Modify Employee APIS -----------------------//
  GetPersonalAndEmergencyInfo: `${Config.server_url}${Config.api_prefix}/Leave/GetMyPersonalInfoAndEmergencyContact`,
  GetEmployeeDetailById: `${Config.server_url}${Config.api_prefix}/Employee`,
  GetDepartmentList: `${Config.server_url}${Config.api_prefix}/Employee/GetDepartmentList`,
  GetSupervisorList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsList`,
  GetSystemRolesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSystemRolesList`,
  GetEmployeeStatusList: `${Config.server_url}${Config.api_prefix}/Employee/GetEmployeeStatusList`,
  UpdateEmployeeInfo: `${Config.server_url}${Config.api_prefix}/Employee`,
};
